import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

export const Toaster = ({ ...props }: ToasterProps) => {
  const isJapanese = document.documentElement.lang === 'ja'

  return (
    <Sonner
      className="toaster group"
      position={'bottom-center'}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:px-6 group-[.toaster]:h-[56px] group-[.toaster]:bg-[#E2DFFF] group-[.toaster]:text-greyscale-100 group-[.toaster]:border-[2px] group-[.toaster]:border-[#0E00A5] group-[.toaster_[data-title]]:text-[16px] group-[.toaster_[data-title]]:leading-[16px] group-[.toaster_[data-title]]:tracking-[.32px] group-[.toaster_[data-title]]:text-[#0E00A5] group-[.toaster]:rounded-[8px] group-[.toaster]:shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] group-[.toaster]:gap-4 [&_[data-icon]]:size-6 [&_[data-icon]]:hidden',
        },
        style: {
          fontFamily: isJapanese ? 'MadouFutoMaruGothic' : 'NeoDunggeunmoPro',
        },
      }}
      {...props}
    />
  )
}
